import { render, staticRenderFns } from "./AddNewMappingSalesAssignment.vue?vue&type=template&id=8148bca2&scoped=true"
import script from "./AddNewMappingSalesAssignment.vue?vue&type=script&lang=js"
export * from "./AddNewMappingSalesAssignment.vue?vue&type=script&lang=js"
import style0 from "./AddNewMappingSalesAssignment.vue?vue&type=style&index=0&id=8148bca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8148bca2",
  null
  
)

export default component.exports